import { ReactNode } from 'react';
import { WorkflowButtons, WorkflowButtonsStore } from './WorkflowButtonsStore';

const workflowButtons: WorkflowButtons = {
    CancelApplicationButton: ({ children }: { children: ReactNode }) => (
        <button>{children ?? 'Cancel'}</button>
    ),
    DoneButton: ({ children }: { children: ReactNode }) => <button>{children ?? 'Done'}</button>,
    CloseWithoutConfirmingButton: ({ children }: { children: ReactNode }) => (
        <button>{children ?? 'Close'}</button>
    ),
};

export const WorkflowButtonsTestProvider = ({ children }: { children: ReactNode }) => {
    return (
        <WorkflowButtonsStore.Provider initialState={workflowButtons}>
            {children}
        </WorkflowButtonsStore.Provider>
    );
};
